export const CSRF_TOKEN = 'bo_csrf_token';
